import { Directive, Input, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

import { toGreeklish } from "./greek-to-latin-characters-converter";

@Directive({
	selector: "input[obgGreekToLatinValue]",
})
export class GreekToLatinCharactersInputValueDirective {
	@Input() obgGreekToLatinValue = false;

	constructor(private ngControl: NgControl) {}
	@HostListener("blur", ["$event.target.value"])
	onBlur(value: string) {
		if (this.obgGreekToLatinValue === true) {
			const latinValue = toGreeklish(value);
			this.ngControl.control?.setValue(latinValue);
		}
	}
}
